import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import { DiscreteFilter, FilterValue } from './offers-filters-model';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { ScreenType } from 'projects/common/model/ScreenType';

@Component({
  selector: 'discrete-filter',
  template: `
    <div [ngClass]="{'flex-container': showAll, 'grid-container grid-template desktop-modal': isModal && !isMobile}">
        <div *ngFor="let column of columns" [ngClass]="[showAll ? 'column' : 'grid-column', columns[0].length > 10 ? 'grid-template' : '']">
          <ng-container *ngIf="filter.multiselector; else singleSelector">
              <eva-checkbox *ngFor="let filterValue of column" size="-lg" [checked]="filterValue.selected && !filterValue.disabled" [disabled]="!!filterValue.disabled"
                  (clickEvent)="updateDiscreteFilter(filter, filterValue)"  [ngClass]="{'with-description': !filterValue.amount && filterValue.description}">
              <span class="filter-label">
                  <em class="filter-name">
                    <span *ngIf="filterValue.icon_src && !filterValue.all_items_choice" class="-eva-3-mr-sm icon"><img [attr.src]="filterValue.icon_src" loading="lazy" alt="icon"></span>
                    <span>{{filterValue.name}}</span>
                  </em>
                  <em *ngIf="filterValue.amount && !(isModal && !isMobile)" class="filter-amount">{{filterValue.amount}}</em>
                  <em *ngIf="!filterValue.amount && filterValue.description"
                    class="filter-description {{filterValue.highlight ? '-highlight' : ''}}">{{filterValue.description}}</em>
              </span>
              </eva-checkbox>
          </ng-container>

          <ng-template #singleSelector>
              <label *ngFor="let filterValue of column" class="-radio-flex-label">
              <span class="eva-3-radio">
                  <label class="radio-label-container">
                  <input class="radio-tag" id="radio-{{filterValue.id}}" type="radio" name="radio-{{filterValue.name}}" value="{{filterValue.id}}"
                      [checked]="filterValue.selected"
                      (click)="updateDiscreteFilter(filter, filterValue)"
                  />
                  <i class="radio-circle"></i>
                  </label>
              </span>
              <span class="filter-label">
                  <em class="filter-name">{{filterValue.name}}</em>
                  <em *ngIf="filterValue.amount" class="filter-amount">{{filterValue.amount}}</em>
                  <em *ngIf="!filterValue.amount && filterValue.description"
                    class="filter-description {{filterValue.highlight ? '-highlight' : ''}}">{{filterValue.description}}</em>
              </span>
              </label>
          </ng-template>
        </div>
    </div>
  `,
  styleUrls: ['offers-filters-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DiscreteFilterComponent implements OnInit {
  @Input() filter: DiscreteFilter;
  @Input() showAll: boolean;
  @Input() isModal = false;

  @Output() discreteFilterChange = new EventEmitter<boolean>();

  columns: FilterValue[][];
  isMobile: boolean;

  constructor(public landingModelService: LandingModelService) {
    this.isMobile =  this.landingModelService.getLandingModel().device.type === ScreenType.MOBILE;
  }

  ngOnInit() {
    if (this.isMobile || (!this.showAll && !this.isModal) || this.filter.values.length < 2) {
      this.columns = [this.filter.values];
    } else {
      this.columns = this.getColumns();
    }
  }

  getColumns(): FilterValue[][] {
    return this.filter.values.reduce((acc: FilterValue[][], val, i) => {
      acc[i % 2].push(val);
      return acc;
    }, [[], []]);
  }

  updateDiscreteFilter(filter: DiscreteFilter, selectedValue: FilterValue) {
    let showRemove: boolean;

    if(filter.multiselector) {
      selectedValue.selected = !selectedValue.selected;
      showRemove = filter.values.some(v => v.selected);
    }
    else {
      selectedValue.selected = true;
      showRemove = true;
      filter.values.filter(filterValue => filterValue != selectedValue).forEach(filterValue => filterValue.selected = false);
    }
    if (selectedValue.all_items_choice){
      if (selectedValue.selected) {
        filter.values
          .filter(filterValue => !filterValue.all_items_choice)
          .forEach(filterValue => {
            filterValue.selected = true;
          });
      } else {
        filter.values.forEach(filterValue => { filterValue.selected = false; filterValue.disabled = false; });
      }
    } else {
      const allFilter = filter.values.find(filterValue => filterValue.all_items_choice);
      if (allFilter) {
        // si están todos seleccionados, seleccionar el "todos"
        const filtersNotselected = filter.values.filter(filterValue => !filterValue.all_items_choice && !filterValue.selected);
        allFilter.selected = filtersNotselected.length === 0;

      }
    }

    this.discreteFilterChange.emit(showRemove);
  }
}
